import { IResourceFields, IResourceGroupFields } from 'generated/types/contentful'
import { Document } from '@contentful/rich-text-types'
import { Entry } from 'contentful'
import { Asset, parseAsset } from '../asset'
import { UnexpectedContentType } from 'services/ContentfulService/errors'

export interface SingleResource {
	key: string
	mediaValue?: Asset
	richTextValue?: Document
	textValue?: string
}

export interface ResourceGroup {
	key: string
	name?: string
	type?: IResourceGroupFields['type']
	resources: SingleResource[]
}

export type Resource =
	| {
			key: string
			contentType: 'resource'
			resource: SingleResource
	  }
	| {
			key: string
			contentType: 'resourceGroup'
			resourceGroup: ResourceGroup
	  }

export const parseSingleResource = (raw: Entry<IResourceFields>): SingleResource => {
	const fields = raw.fields
	return {
		key: fields.key,
		mediaValue: fields.mediaValue && parseAsset(fields.mediaValue),
		richTextValue: fields.richTextValue,
		textValue: fields.value
	}
}

const parseResourceGroup = (raw: Entry<IResourceGroupFields>): ResourceGroup => {
	const fields = raw.fields
	return {
		key: fields.key,
		name: fields.name,
		type: fields.type,
		resources: fields.resources.map(rawResource => parseSingleResource(rawResource))
	}
}

export const parseResource = (raw: Entry<IResourceFields | IResourceGroupFields>): Resource => {
	// eslint-disable-next-line @typescript-eslint/ban-ts-comment
	// @ts-ignore
	const contentType = raw.sys?.contentType.sys.id as string
	switch (contentType) {
		case 'resource':
			const resource = parseSingleResource(raw as Entry<IResourceFields>)
			return { contentType: 'resource', resource, key: resource.key }
		case 'resourceGroup':
			const resourceGroup = parseResourceGroup(raw as Entry<IResourceGroupFields>)
			return { contentType: 'resourceGroup', resourceGroup, key: resourceGroup.key }
	}
	throw new UnexpectedContentType(`Expected Resource or ResourceGroup. Found ${contentType} instead`)
}
